import { FormCreationData } from "../../../../../stateManager/store/formCreation_v2/types";

export function getNestedComponents(components: {[key: string]: any}, fields: string[], array: FormCreationData[] = []) {
    fields.forEach((fieldId: string) => {
        const component = components[fieldId];
        array.push(component);
        // recursively all fields
        if (component?.fields?.length) {
            getNestedComponents(components, component.fields, array);
        }
    })
}